import React, {Component} from 'react';
import {Grid, Row, Col, ControlLabel} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import ReactNotify from 'react-notify';
import {TopSelect} from "../../../componentsTopsa/selects/TopSelects";
import KsiegowoscService from "./KsiegowoscService";
import DynamicTable from "./components/DynamicTable";

const typyRaportu = [{label: 'Sprawdzenie na fakturach czy są jakieś dokumenty nie wysłane, spełniające warunki', value: '1'}, { label: 'Raport wysłanych faktur', value: '2' }, { label: 'Sprawdzenie na biletach jednorazowych czy jest jakiś do wysyłki ', value: '3'}, { label: 'Sprawdzanie na biletach miesięcznych czy jest jakiś do wysyłki', value: '4'}];

export default class KsiegowoscContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            raport: null,
            setLoader: false,
            setLoaderRaport: false,
            selectedTyp: null,
        };
    }

    onChangeTyp = (e) => {
        console.log(e);
        this.setState({selectedTyp: e})

        if(e === null) {
            this.setState({raport: null})
        } else {
            this.pobierzRaportKsiegowy(e.value);
        }
    }

    pobierzRaportKsiegowy = (typ) => {
        this.setState({raport: [], setLoaderRaport: true});
        KsiegowoscService.pobierzRaport(typ).then((response) => {
            console.log(response.data);
            this.setState({raport: response.data, setLoaderRaport: false});
        }).catch( (err) => {
            console.log(err);
        })
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'RaportyContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb
                                    links={[{addressUrl: '/raporty', text: 'Raporty'}, {
                                        addressUrl: '/raporty/ksiwgowosc',
                                        text: 'Ksiegowość'
                                    }]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col xs={6}>
                            <ControlLabel>Typ raportu: </ControlLabel>
                            <TopSelect onChange={(e) => this.onChangeTyp(e)}
                                       value={this.state.selectedTyp}
                                       options={typyRaportu}
                                       labelKey={'label'}
                                       valueKey={'value'}
                                       // valueRenderer={this.formatLiniaSelect}
                                       // optionRenderer={this.formatLiniaSelect}
                                       placeholder={'Wybierz typ raportu'}
                            />
                        </Col>
                        <Col xs={12}>
                            {
                                Boolean(this.state.setLoaderRaport) ?
                                    <div id={'smallLoader'}>
                                        <i className={'fa fa-circle-o-notch fa-spin'}></i>
                                        <div>Trwa ładowanie raportu...</div>
                                    </div>
                                    :
                                    <div>
                                        {(this.state.raport != null) && <div>
                                            <h2 style={{textAlign:'left', borderBottom:'1px solid #83c33a', paddingBottom:'5px'}}>{this.state.selectedTyp.label}</h2>
                                            <DynamicTable data={this.state.raport} />
                                        </div>
                                        }
                                    </div>
                            }
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/Ksiegowosc/KsiegowoscContainer.js